import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportDetailsDialogActionComponent } from './transport-details-dialog-action/transport-details-dialog-action.component';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';
import { MaterialModule } from '@sdbn/appclient';
import { LinkTransportDialogActionComponent } from './link-transport-dialog-action/link-transport-dialog-action.component';
import { AttachDetachTransportDialogActionComponent } from './attach-detach-transport-dialog-action/attach-detach-transport-dialog-action.component';
import { ResendMessageActionComponent } from './resend-message-action/resend-message-action.component';
import { RegisterEntranceActionComponent } from './register-entrance-action/register-entrance-action.component';
import { RegisterEntranceLeaveModule } from '../register-entrance-leave/register-entrance-leave.module';


@NgModule({
  declarations: [
    TransportDetailsDialogActionComponent,
    LinkTransportDialogActionComponent,
    AttachDetachTransportDialogActionComponent,
    ResendMessageActionComponent,
    RegisterEntranceActionComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    MaterialModule,
    RegisterEntranceLeaveModule,

    CommonUIElementsModule
  ],
  exports: [
    TransportDetailsDialogActionComponent,
    LinkTransportDialogActionComponent,
    AttachDetachTransportDialogActionComponent,
    ResendMessageActionComponent,
    RegisterEntranceActionComponent
  ]
})
export class ActionsModule { }
